<div class="h-full min-h-0 flex flex-col justify-start w-full overflow-hidden gap-4">
    <!-- Header -->
    <div class="shrink-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <div class="">
                <div class="inline-flex items-center gap-x-2">
                    <h3 class="text-md font-semibold text-primary">Video Moderation Status
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">Which videos have been reviewed by AI moderation?</p>
            </div>
        </div>

        <div class="flex flex-row items-center justify-end gap-x-4">
            <nav aria-label="Tabs" class="flex space-x-2">
                <a (click)="selectReviewState(-1)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass(-1)">Not Reviewed</a>
                <a (click)="selectReviewState(0)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass(0)">All</a>
                <a (click)="selectReviewState(1)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass(1)">Reviewed</a>

            </nav>
        </div>
    </div>
    <!-- Header - END -->

    <!-- Main Content -->
    <div class="flex-1 min-h-0 flex flex-col w-full overflow-hidden">
        @if (videoAiModerationInsights() && videoAiModerationInsights()!.length > 0) {
        <div class="w-full min-h-0 flex-1 flex flex-col overflow-hidden">
            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="h-full min-h-0 overflow-x-auto">
                    <div class="inline-block min-h-0 h-full min-w-full align-middle">
                        <div class="data-table-wrapper h-full min-h-0 flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50"
                                #scrollContainer infinite-scroll [infiniteScrollDistance]="2"
                                [infiniteScrollThrottle]="100" [infiniteScrollContainer]="scrollContainer"
                                [infiniteScrollDisabled]="!hasMore() || isLoadingMore()"
                                (scrolled)="onScrollDown()">
                                <table class="data-table min-w-full">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col" class="text-left text-sm font-semibold">
                                                Video
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold">Brief
                                            </th>

                                            <th scope="col" class="text-left text-sm font-semibold">Score
                                            </th>

                                            <th scope="col" class="text-left text-sm font-semibold">SHOUT AI Enabled
                                            </th>
                                            <th scope="col" class="text-right text-sm">
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        @for (video of videoAiModerationInsights(); track video.id) {
                                        <tr>
                                            <td class="text-sm font-medium whitespace-nowrap">
                                                <div class="flex items-center">
                                                    <div class="relative h-20 aspect-9/16 shrink-0 cursor-pointer">
                                                        <atom-video-thumbnail [videoUrl]="video.fullUrl"
                                                            [thumbnailURL]="video.thumbnailURL ? video.thumbnailURL : undefined"
                                                            [cdnKey]="video.thumbnailCdnKey ? video.thumbnailCdnKey : undefined"
                                                            [videoFormat]="video.videoFormat"></atom-video-thumbnail>
                                                    </div>
                                                    <div class="ml-4">
                                                        <h3
                                                            class="text-base font-semibold text-gray-900 dark:text-white">
                                                            {{ video.videoName }}</h3>
                                                        <p class="text-sm text-gray-500 dark:text-gray-400">{{
                                                            video.creator.firstName }} {{
                                                            video.creator.lastName?.charAt(0) }}.</p>
                                                        <p class="text-sm text-gray-500 dark:text-gray-400">{{
                                                            formatService.getTimeSinceUpdated(video.createdDate) }}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-sm whitespace-nowrap">
                                                <div class="">
                                                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                                                        {{ video.brief.title }}</h3>
                                                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ video.brief.businessAccount.companyName }}</p>
                                                    <p class="text-sm text-gray-500 dark:text-gray-400 hover:cursor-pointer hover:underline" (click)="copyBriefId(video.brief.id)">{{ video.brief.id }}</p>
                                                </div>
                                            </td>

                                            <td class="text-sm whitespace-nowrap">
                                                @if (video.aiModerateScore !== null) {
                                                <p class="text-green-500">{{ video.aiModerateScore }}%</p>
                                                } @else {
                                                <p class="text-amber-500">N/A</p>
                                                }

                                            </td>
                                            <td class="text-sm whitespace-nowrap">
                                                {{video.brief.noodleEnabled ? 'Yes' : 'No'}}
                                            </td>

                                            <td class="text-right text-sm font-medium whitespace-nowrap">
                                                @if (video.aiModerateScore == null) {
                                                @if (currentlyProcessing().indexOf(video.id) == -1) {
                                                <button type="button" class="fab-button-primary"
                                                    (click)="startProcessing(video.id)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-5">
                                                        <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                                                        <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                                                        <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                                                        <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                                                        <circle cx="12" cy="12" r="3" />
                                                        <path d="m16 16-1.9-1.9" />
                                                    </svg>
                                                </button>
                                                } @else {
                                                <button type="button" class="rounded-full bg-gray-500 p-1.5 text-black">

                                                    <svg aria-hidden="true"
                                                        class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                                        viewBox="0 0 100 101" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                            fill="currentColor" />
                                                        <path
                                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                            fill="currentFill" />
                                                    </svg>


                                                </button>
                                                }
                                                }

                                            </td>
                                        </tr>
                                        }

                                        @if (isLoadingMore()) {
                                        <tr>
                                            <td colspan="5" class="py-4 text-center text-sm text-secondary">
                                                Loading more videos…
                                            </td>
                                        </tr>
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        @else if (videoAiModerationInsights() && videoAiModerationInsights()!.length == 0) {
        <p>No videos found</p>
        }
        @else {
        <p>Loading...</p>
        }
    </div>
    <!-- Main Content - END -->
</div>